import React, { useEffect, useState } from "react";
import { PRIMARY_COLOR } from "../../assets/style/colors";
import { back_icon1, bg, eyeClose, eyeOpen, Logo, pass_un, password_view } from "../../assets/img";
import { useLocation, useNavigate } from "react-router-dom";
import { URLS } from "../../Services/Constant";
import { post } from "../../Services/ApiHandler";
import { Toast } from "../../Component/Toast";
import useStore from "../redux/store/useStore";
import SubmitButton from "../../Component/SubmitButton";
import { MaskIcon } from "../MaskIcon";

const CreatePassword = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const userID = location.state?.id;
  const type = location.state?.type;
  const { setUser } = useStore();
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [password, setPassword] = useState("");
  const [confirmPasswordInput, setConfirmPasswordInput] = useState("");
  const [loading, setLoading] = useState(false);
  const [isFormValid, setIsFormValid] = useState(false);

  useEffect(() => {
    // // console.log("userID:", userID, type);
  }, [userID, type]);

  const togglePassword = () => {
    setShowPassword((prev) => !prev);
  };

  const toggleConfirmPassword = () => {
    setShowConfirmPassword((prev) => !prev);
  };

  useEffect(() => {
    const isPasswordValid = password.length >= 4;
    const isConfirmPasswordValid =
      confirmPasswordInput === password && confirmPasswordInput.length > 0;
    setIsFormValid(isPasswordValid && isConfirmPasswordValid);
  }, [password, confirmPasswordInput]);

  const handleConfirm = async (e) => {
    e.preventDefault();

    if (password !== confirmPasswordInput) {
      Toast("Passwords do not match");
      return;
    }

    const formdata = {
      user_id: userID,
      password: password,
      password_confirmation: confirmPasswordInput,
      type: type,
    };

    try {
      setLoading(true);
      const res = await post(URLS.CHANGEPASSWORD, formdata);
      // // console.log("Change password response:", res);

      if (res?.status === "success") {
        Toast("Password created successfully!");
        if (res?.is_register == true) {
          setUser({
            name: res?.user?.name,
            id: res?.user?.id,
            mobile: res?.user?.mobile,
          });
          await localStorage.setItem("token", res.token);
          navigate("/home", { replace: true });
        } else {
          navigate("/", { replace: true });
        }
      } else {
        Toast(res?.message || "Failed to create password");
      }
    } catch (err) {
      console.error("Error creating password:", err);
      Toast("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
  <div style={{ backgroundColor: '#F0EDE6', minHeight: '100vh', overflow: 'hidden' }}>

    {/* ===== DESKTOP LAYOUT ===== */}
    <div className="d-none d-lg-flex" style={{ height: '100vh' }}>

      {/* LEFT */}
      <div style={{
        width: '50%',
        backgroundImage: "url('https://winner-ags.s3.us-east-1.amazonaws.com/Royal-agency/vasv4x+3.png')",
        backgroundColor: PRIMARY_COLOR,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}>
        <img src={Logo} alt="Logo" style={{ maxWidth: 400, width: '100%' }} />
      </div>

      {/* RIGHT */}
      <div style={{
        width: '50%',
        backgroundColor: '#F0EDE6',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '2rem',
      }}>
        <form style={{ width: '100%', maxWidth: 420 }} onSubmit={handleConfirm}>
            <span style={{ display: 'flex', gap: 15, alignItems: 'center', cursor: 'pointer' }}
              onClick={() => navigate(-1)}>
              <img src={back_icon1} height={18} width={18} alt="back" />
              <h2 style={{ color: 'black', margin: 0 }} className="f3">
                Create Password
              </h2>
            </span>

          {/* Password */}
          <div style={{ marginTop: 35 }} className="form-group text-start">
            <label style={{ color: PRIMARY_COLOR }} className="form-label f3 mb-0">
              Password
            </label>
            <div className="login-input mt-1 d-flex align-items-center justify-content-between"
              style={{ backgroundColor: '#F0EDE6' }}>
              <input
                type={showPassword ? 'text' : 'password'}
                placeholder="Enter Password"
                required
                className="placholdercolorchanges f2"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                style={{ height: 50, backgroundColor: '#F0EDE6', border: 'none', width: '90%', borderRadius: 8 }}
              />
              <MaskIcon
                src={showPassword ? eyeOpen : eyeClose}
                onClick={togglePassword}
                alt="toggle password"
                style={{ width: 18, height: 18, cursor: 'pointer', marginRight: 10 }}
              />
            </div>
          </div>

          {/* Confirm Password */}
          <div style={{ marginTop: 25 }} className="form-group text-start">
            <label style={{ color: PRIMARY_COLOR }} className="form-label f3 mb-0">
              Confirm Password
            </label>
            <div className="login-input mt-1 d-flex align-items-center justify-content-between"
              style={{ backgroundColor: '#F0EDE6' }}>
              <input
                type={showConfirmPassword ? 'text' : 'password'}
                placeholder="Confirm Password"
                required
                className="placholdercolorchanges f2"
                value={confirmPasswordInput}
                onChange={(e) => setConfirmPasswordInput(e.target.value)}
                style={{ height: 50, backgroundColor: '#F0EDE6', border: 'none', width: '90%', borderRadius: 8 }}
              />
              <MaskIcon
                src={showConfirmPassword ? eyeOpen : eyeClose}
                onClick={toggleConfirmPassword}
                alt="toggle confirm password"
                style={{ width: 25, height: 18, cursor: 'pointer', marginRight: 10 }}
              />
            </div>
          </div>

          <SubmitButton
            onClick={handleConfirm}
            title="Confirm"
            disabled={loading}
            isFormValid={!isFormValid}
            loading={loading}
          />
        </form>
      </div>
    </div>

    {/* ===== MOBILE LAYOUT ===== */}
    <div className="d-flex d-lg-none" style={{ flexDirection: 'column', minHeight: '100vh' }}>

      {/* TOP - Image */}
      <div style={{
        backgroundImage: "url('https://winner-ags.s3.us-east-1.amazonaws.com/Royal-agency/vasv4x+3.png')",
        backgroundColor: PRIMARY_COLOR,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        minHeight: '45vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}>
        <img src={Logo} alt="Logo"
          style={{ maxWidth: 277, maxHeight: 277, width: '100%', position: 'relative', bottom: 12 }} />
      </div>

      {/* BOTTOM - Form */}
      <div style={{
        backgroundColor: '#F0EDE6',
        borderRadius: '60px 60px 0 0',
        marginTop: '-50px',
        zIndex: 1,
        position: 'relative',
        padding: '50px 24px 40px',
        flex: 1,
      }}>
        <form style={{ maxWidth: 420, width: '100%', margin: '0 auto' }} onSubmit={handleConfirm}>
          <h2 style={{ color: 'black', margin: 0, fontSize: 20 }} className="f3">
            Create Password
          </h2>

          {/* Password */}
          <div style={{ marginTop: 25 }} className="form-group text-start">
            <label style={{ color: PRIMARY_COLOR }} className="form-label f3 mb-0">
              Password
            </label>
            <div className="login-input mt-1 d-flex align-items-center justify-content-between"
              style={{ backgroundColor: '#F0EDE6' }}>
              <input
                type={showPassword ? 'text' : 'password'}
                placeholder="Enter Password"
                required
                className="placholdercolorchanges f2"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                style={{ height: 50, backgroundColor: '#F0EDE6', border: 'none', width: '90%', borderRadius: 8 }}
              />
              <MaskIcon
                src={showPassword ? eyeOpen : eyeClose}
                onClick={togglePassword}
                alt="toggle password"
                style={{ width: 25, height: 18, cursor: 'pointer', marginRight: 10 }}
              />
            </div>
          </div>

          {/* Confirm Password */}
          <div style={{ marginTop: 25 ,marginBottom:15}} className="form-group text-start">
            <label style={{ color: PRIMARY_COLOR }} className="form-label f3 mb-0">
              Confirm Password
            </label>
            <div className="login-input mt-1 d-flex align-items-center justify-content-between"
              style={{ backgroundColor: '#F0EDE6' }}>
              <input
                type={showConfirmPassword ? 'text' : 'password'}
                placeholder="Confirm Password"
                required
                className="placholdercolorchanges f2"
                value={confirmPasswordInput}
                onChange={(e) => setConfirmPasswordInput(e.target.value)}
                style={{ height: 50, backgroundColor: '#F0EDE6', border: 'none', width: '90%', borderRadius: 8 }}
              />
              <MaskIcon
                src={showConfirmPassword ? eyeOpen : eyeClose}
                onClick={toggleConfirmPassword}
                alt="toggle confirm password"
                style={{ width: 25, height: 18, cursor: 'pointer', marginRight: 10 }}
              />
            </div>
          </div>

          <SubmitButton
            onClick={handleConfirm}
            title="Confirm"
            disabled={loading}
            isFormValid={!isFormValid}
            loading={loading}
          />
        </form>
      </div>
    </div>

  </div>
);
};

export default CreatePassword;
